export const enum GeneralStatusEnum {
  ACTIVE = 'ACTIVE',
  DRAFT = 'DRAFT',
  PENDING_ONBOARDING = 'PENDING_ONBOARDING',
  PENDING_ACTION = 'PENDING_ACTION',
  ARCHIVED = 'ARCHIVED',
  ON_HOLD = 'ON_HOLD',
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  UNPUBLISHED = 'UNPUBLISHED',
  ONBOARDING = 'ONBOARDING',
  INACTIVE = 'INACTIVE'
}
